[
    {
        "category": "ECOM",
        "value": "Maxis Postpaid & K2 Device",
        "product": "Maxis Postpaid",
        "customerSubType": "Maxis Individual",
        "familyType": "MOP",
        "contractType": "K2"
    },
    {
        "category": "ECOMZerolution",
        "value": "Maxis Postpaid & Zerolution Device",
        "product": "Maxis Postpaid",
        "customerSubType": "Maxis Individual",
        "familyType": "MOP",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMHOTLINKPREPAIDUNLIMITED",
        "value": "Hotlink Prepaid & Prepaid Port In",
        "product": "Hotlink Prepaid",
        "customerSubType": "Individual"
    },
    {
        "category": "EcomMaxisPostpaidSSTC",
        "value": "Maxis Postpaid & Plan Only",
        "product": "Maxis Postpaid",
        "customerSubType": "Maxis Individual",
        "familyType": "MOP",
        "contractType": "No Device"
    },
    {
        "category": "EcomHotlinkPostpaidPlansServices",
        "value": "Hotlink Postpaid & Plan Only/Port In/K2 Device",
        "product": "Hotlink Postpaid",
        "customerSubType": "Hotlink Individual"
    },
    {
        "category": "EcomHotlinkPrepaidOnlineBundle",
        "value": "Hotlink Prepaid & SIM Pack",
        "product": "Hotlink Prepaid",
        "customerSubType": "Individual"
    },
    {
        "category": "EcomMaxisFibre",
        "value": "Maxis Fibre Only",
        "product": "Maxis Fibre",
        "customerSubType": "Maxis Individual",
        "familyType": "FTTH"
    },
    {
        "category": "EcomHotlink",
        "product": "Hotlink Postpaid",
        "contractType": "K2"
    },
    {
        "category": "EcomMaxisFibreMop",
        "value": "Maxis Fibre + MOP",
        "product": "Maxis Fibre",
        "customerSubType": "Maxis Individual",
        "familyType": "FTTH & MOP"
    },
    {
        "category": "EcomMaxisFWBBOnly",
        "value": "Maxis FWBB Plan Only",
        "product": "Maxis FWBB",
        "customerSubType": "Maxis Individual",
        "familyType": "FWBB"
    },
    {
        "category": "EcomMaxisFWBBMOPWIFIRouter",
        "value": "Maxis FWBB + MOP",
        "product": "Maxis FWBB + MUP",
        "customerSubType": "Maxis Individual",
        "familyType": "FWBB & MOP",
        "contractType": "K2"
    },
    {
        "category": "EcomMaxisFWBBWIFIRouter",
        "value": "Maxis FWBB + K2 Contract",
        "product": "Maxis FWBB",
        "customerSubType": "Maxis Individual",
        "familyType": "FWBB",
        "contractType": "K2"
    },
    {
        "category": "BusIndSTCA",
        "value": "Maxis Postpaid for Business Individual Offer A",
        "product": "Maxis Postpaid",
        "customerSubType": "Maxis Individual",
        "familyType": "MOP"
    },
    {
        "category": "BusIndSTCB",
        "value": "Maxis Postpaid for Business Individual Offer B",
        "product": "Maxis Postpaid",
        "customerSubType": "Maxis Individual",
        "familyType": "MOP"
    },
    {
        "category": "ECOMHP60",
        "value": "Hotlink Postpaid + Zerolution ",
        "product": "Hotlink Postpaid",
        "customerSubType": "Hotlink Individual",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMMaxisFamily",
        "product": "Maxis Family"
    },
    {
        "category": "ECOMZerolution",
        "product": "Maxis Family",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMZerolution",
        "product": "Maxis Family Plan & Zerolution Device",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMMaxisHomeDevice",
        "product": "Maxis FWBB",
        "contractType": "Zerolution",
        "familyType": "FWBB"
    },
    {
        "category": "ECOMMaxisHomeDevice",
        "product": "Maxis Fibre",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMMaxisFamily48",
        "product": "Maxis Family Plan Additional Member 48"
    },
    {
        "category": "ECOMMaxisWatch",
        "product": "Maxis Postpaid",
        "familyType": "WATCH",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMMaxisTablet",
        "product": "Maxis Postpaid",
        "familyType": "TABLET",
        "contractType": "Zerolution"
    },
    {
        "category": "ECOMMaxisMP68",
        "product": "Maxis Postpaid 68"
    },
    {
        "category": "ECOMMaxisFamilyUnlimited",
        "product": "Maxis Fibre + Maxis Postpaid 68"
    },
    {
        "category": "ECOMMaxisShare48",
        "product": "Maxis Postpaid Share 48"
    },
    {
        "category": "ECOMMaxisMP68",
        "product": "MOP 68 + SUPP"
    }
]